define.alias("shared/components/shared/base-time-picker", "preview-grid/components/shared/base-time-picker");